<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h1>Inbox</h1>
        <p>Welcome to your inbox. Below you will see any document requests from your dealer.</p>
        <span v-if="loading">
          <font-awesome-icon
            icon="circle-notch"
            spin
          /> Loading...
        </span>
        <template v-else>
          <p
            v-if="!requests || requests.length === 0"
          >
            No document requests
          </p>
          <request-box-view
            v-else
            :requests="requests"
          />
        </template>
      </div>
    </div>

    <div
      v-if="recentlyRequestedDocuments.length"
      class="row"
    >
      <div class="col-xs-12">
        <div class="panel panel-default">
          <ul class="list-group">
            <li
              class="list-group-item active"
            >
              Recently Requested Documents
            </li>
            <div
              v-for="req in completeRequests"
              :key="`req${req.id}`"
            >
              <li
                v-for="doc in req.documents"
                :key="`doc${doc.id}`"
                class="list-group-item"
              >
                <document-view
                  :deal-id="doc.deal_id"
                  :dealer-name="req.dealer_name"
                  :doc="doc"
                />
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import RequestBoxView from '../common/requestBox.vue';
import DocumentView from './record/document.vue';

export default {
  components: {
    DocumentView,
    RequestBoxView,
  },

  data() {
    return {
      requests: [],
      completeRequests: [],
      loading: true,
    };
  },

  computed: {
    recentlyRequestedDocuments() {
      const documents = _.reduce(
        this.completeRequests,
        (accum, req) => accum.concat(req.documents),
        [],
      );

      return _.take(documents, 5);
    },
  },

  mounted() {
    this.fetchRequests();
    this.fetchCompleteRequests();
  },

  methods: {
    fetchRequests() {
      const app = this;
      app.ApiService.fetchRequests()
        .then((response) => {
          app.requests = response;
        })
        .catch((error) => {
          app.alertBox({ type: 'error', message: error }).then(() => {
            app.requests = [];
          }).catch();
        })
        .finally(() => {
          app.loading = false;
        });
    },
    fetchCompleteRequests() {
      const app = this;
      app.ApiService.fetchRequests(true)
        .then((response) => {
          app.completeRequests = response;
        })
        .catch((error) => {
          app.alertBox({ type: 'error', message: error }).then(() => {
            app.requests = [];
          }).catch();
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
